import React from 'react';
import { MessageCircle, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { startSupportChat } from '../../api/api';

export default function FloatingChatSupport() {
  const navigate = useNavigate();
  const { t, dir } = useLanguage();
  const [isStarting, setIsStarting] = React.useState(false);

  const handleOpenSupport = async () => {
    if (isStarting) return;
    setIsStarting(true);
    try {
        const conversation = await startSupportChat();
        if (conversation && conversation._id) {
            navigate(`/messages/${conversation._id}`);
        } else {
            navigate('/messages');
        }
    } catch (error) {
        console.error('Failed to start support chat:', error);
        navigate('/messages');
    } finally {
        setIsStarting(false);
    }
  };

  return (
    <div className="fixed bottom-20 right-5 sm:right-6 z-[75]">
      <button
        onClick={handleOpenSupport}
        disabled={isStarting}
        className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-card/95 dark:bg-background/95 text-primary backdrop-blur-2xl border border-white/20 shadow-xl flex items-center justify-center hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none cursor-pointer disabled:opacity-50"
        title={t('supportChat', 'Support Chat')}
      >
        {isStarting ? <Loader2 className="animate-spin" size={20} /> : <MessageCircle size={20} />}
      </button>
    </div>
  );
}
